"use strict";

class CustomerPropertyAssetsController {
    constructor($scope, Fullscreen, SSHttpService, SSUtilService, SSAppService, SSUserService, SSDisclaimerService) {

        const self = this;

        self.$scope = $scope;
        self.Fullscreen = Fullscreen;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSDisclaimerService = SSDisclaimerService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        self.PROPERTY_ASSET_TYPE_SHOW_GALLERY_360 = SHOWSUITE.PROPERTY_ASSET_TYPE_SHOW_GALLERY_360;
        self.PROPERTY_ASSET_TYPE_ARCHITECTURAL_360 = SHOWSUITE.PROPERTY_ASSET_TYPE_ARCHITECTURAL_360;
        
        self.init();

    }

    init() {
        const self = this;

        self.filterAssets();
    }

    filterAssets(){
        const self = this;

        if (self.property.property_assets) {

            let assets = [];

            if(self.data.asset_type == "gallery360"){
                assets = self.property.property_assets.filter(x => x.type === self.PROPERTY_ASSET_TYPE_SHOW_GALLERY_360);
            }
            else if(self.data.asset_type == "architectural-model"){
                assets = self.property.property_assets.filter(x => x.type === self.PROPERTY_ASSET_TYPE_ARCHITECTURAL_360);
            }

            if(assets && self.data.asset_id){
                self.assets = assets.filter(x => x.id === parseInt(self.data.asset_id));
            }
            else{
                self.assets = assets;
            }
        }
    }

    toggleFullScreen(event) {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.Fullscreen.cancel();
        } else {
            if (!event) return;

            if (typeof event == "string") {
                self.Fullscreen.enable(document.getElementById(event));
            } else if (event.currentTarget.tagName === "BUTTON") {
                self.Fullscreen.enable(event.currentTarget.parentNode);
            } else {
                self.Fullscreen.enable(event.currentTarget);
            }
        }
    }
}

CustomerPropertyAssetsController.$inject = ['$scope', 'Fullscreen', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSDisclaimerService'];
app.controller('CustomerPropertyAssetsController', CustomerPropertyAssetsController);
